import React, { useEffect } from 'react'
import './AboutUs.scss'

import { Link } from 'react-router-dom'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function AboutUs() {
  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='aboutUsPartAr'>
      <div className="container">
        <div className="row">
          <div className="aboutUs_contents" data-aos='fade-left'>
            <div className="aboutUs_content">
              <h1 className="ourProducts_contents_title">
                GLOBAL ENERGY INVESTMENT
              </h1>
              <h3 className="ourProducts_contents_subtitle">
                نحن شركات هندسية واستشارية وتجارة دولية تعمل في قطاع صناعة الصلب والبناء. نشاط شركاتنا بشكل رئيسي في تركيا وعمان.                 <br />
                <br />
                ”Vigor Global Energy company “VGE شرکة
                و مقرها إسطنبول،ترکیا و شرکة       
                <br />
                ”Global Energy Investment “GEI
                و مقرها مسقط ، عمان.
                <br /><br />
                شركاتنا في قطاع الصلب هي الممثل الرسمي لمجمع كافير للصلب (أحد أكبر منتجي منتجات الصلب في الشرق الأوسط) في تركيا وعمان والدول الأفريقية. نحن نعمل بشكل وثيق مع شركات التصنيع والبناء الرائدة في تركيا وعمان ودول أخرى لتصدير منتجات عالية الجودة من الحديد والصلب مثل قضبان الأسلاك وسبائك الصلب وقضبان التسليح ذات الدرجة الخاصة والشهادات الأوروبية إلى العديد من المصانع المستخدمة كمواد خام مادة.
                <br />
                <Link to='/ar/corperate'>أكثر</Link>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="aboutUsImage" data-aos='fade-right'>
      </div>
    </div>
  )
}
